module.exports = __webpack_public_path__ + "img/menu.1bf392e4.svg";